export enum SubRowType {
  Data = 'data',
  ExpandCollapse = 'showMore',
}

export interface BaseSubRow {
  index: number;
  subRowId: string;
  subRowIndex: number;
  rowId: string;
  rowIndex: number;
  subRowType: SubRowType;
  loading: boolean;
  chunkIndex?: number;
}

export interface DataSubRow extends BaseSubRow {
  rowData: Record<string, string>; // TODO: To rename to "cells"
}

export interface ExpandCollapseRow extends BaseSubRow {
  displayedChunksCount?: number;
  hiddenChunksCount?: number;
}
